import Vue from "vue"
import { AclInstaller, AclCreate, AclRule } from "vue-acl"
import router from "@/router"
import auth from "../auth/authService.js"

Vue.use(AclInstaller)

let initialRole = "Public"

export default new AclCreate({
  initial: initialRole,
  notfound: "/login",
  router,
  acceptLocalRules: true,
  globalRules: {
    SuperAdmin: new AclRule("SuperAdmin").generate(),
    Admin: new AclRule("Admin").or("SuperAdmin").generate(),
    Simple: new AclRule("Simple").or("Admin").or("SuperAdmin").generate(),
    Public: new AclRule("Public").generate(),
    TeleCogepha: new AclRule("TeleCogepha").generate(),
    Fournisseur: new AclRule("Fournisseur").generate(),
    GestionArticlePortail: new AclRule("GestionArticlePortail").or('GestionnairePortail').generate(),
    GestionnairePortail: new AclRule("GestionnairePortail").generate(),
    Gestionnaire: new AclRule("GestionnairePortail").or("GestionArticlePortail").or('GestionFournisseurPortail').generate(),
    GestionFournisseurPortail: new AclRule('GestionFournisseurPortail').or('GestionnairePortail').generate(),
    Authenticated: new AclRule("TeleCogepha").or("Simple").or("Admin").or("SuperAdmin").or("Fournisseur").or("GestionnairePortail").or("GestionArticlePortail").or('GestionFournisseurPortail').generate(),


    // public: new AclRule("public").or("admin").or("editor").generate(),
  },
  middleware: async acl => {
    await auth.getRole();
    acl.change(auth.getRole())

  }
})